<template>
  <GenericDataView
    v-slot="{id, loading, isUpdateForm}"
    title="Product Components"
    local-storage-key="productComponents"
    :state="productComponents"
    :read="productComponentsStore.readProductComponents"
    :set="productComponentsStore.setProductComponents"
    :delete="productComponentsStore.deleteProductComponent"
    :cols-map="colsMap"
    :cached="cached"
    @cached="cached = true"
  >
    <ProductComponentForm :id="id" :loading="loading" :is-update-form="isUpdateForm" />
  </GenericDataView>
</template>
<script setup lang="ts">
import {ProductComponent} from '@/stores/userManagement/userManagement';

const productComponentsStore = useProductComponentsStore();
const {productComponents} = storeToRefs(productComponentsStore);
const cached = ref(false);

const colsMap = readonly<{[key: string]: keyof ProductComponent}>({
  'Product Component': 'name',
  'Component Type': 'component_type_id',
  'Cost Pool': 'cost_pool_id',
  'Personal Data Stored': 'personal_data_stored',
});
</script>
